'use strict';

const Reflux = require('@muzzylane/reflux');
const findIndex = require('lodash/findIndex');

var ServerRequest = require('../actions/request'),
    SignInStore = require('./SignInStore'),
    ForgeError = require('../util/error'),
    ErrorConsts = require('../constants/error'),
    RegistrationTokenActions = require('../actions/registration_token_actions');
var SignInActions = require('../actions/sign_in_actions');

var tokens = [];
var initialized = false;
var action = {};
var error = null;

var RegistrationTokenStore = Reflux.createStore({
    listenables: [RegistrationTokenActions,SignInActions],
    init: function() {
        var signInStoreState = SignInStore.getState();
        if(signInStoreState.initializedLocal && signInStoreState.userInfo.admin){
            this.getTokens();
        }

        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        tokens = [];
        initialized = false;
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState){
        if(signInStoreState.initializedLocal && signInStoreState.userInfo.admin){
            this.getRegTokens();
        }
    },

    getState: function() {
        return {
            initialized: initialized,
            tokens: tokens,
            action: action,
            error: error
        }
    },

    emitStatus: function() {
        //console.log("activity store: EMIT");
        this.trigger(this.getState());
        action = {};
        //error = null; //maybe?
    },

    getRegTokens: function() {
        var self = this;

        ServerRequest.makeRequest('/authoring/registration_tokens', 'GET')
            .then(function(res) {
                //console.log("getRegTokens: SUCCESS");
                //console.log(res);
                error = null;
                tokens = res;
            })
            .catch(function(err) {
                console.warn("getRegTokens: FAILURE", err);

                switch(err.status){
                    case 403:
                        error = new ForgeError({message: "Forbidden"});
                        break;
                    case 422:
                        error = new ForgeError({message: "Invalid input"});
                        break;
                    default:
                        error = new ForgeError({message: "Internal server error. Unable to fetch registration tokens. Please try again later."});
                }

                self.emitStatus();
            })
            .finally(function() {
                initialized = true;
                self.emitStatus();
            })
    },

    onError: function(actionID, err) {
        action.id = actionID;

        if(err.status){
            switch(err.status){
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onUpdateRegTokenProjectCompleted: function(actionID, regToken) {
        // console.log("onUpdateRegTokenProjectCompleted: ", actionID, regToken);
        action.id = actionID;

        let index = findIndex(tokens, {id: regToken.id});
        let newTokens = tokens.slice(0, index).concat(tokens.slice(index+1, tokens.length-1)); //create new array with oudated regToken removed
        newTokens.push(regToken);

        tokens = newTokens;

        this.emitStatus();
    },

    onUpdateRegTokenProjectFailed: function(actionID, err) {
        console.warn("onUpdateRegTokenProjectFailed: ", actionID, err);
       this.onError(actionID, err);
    },

    onAddTokenCompleted: function(actionID, regToken) {
        // console.log("onAddTokenCompleted: ", actionID, regToken);
        action.id = actionID;

        // let newTokens = _.cloneDeep(tokens);
        // newTokens.push(regToken); //immuatable?
        // tokens = newTokens;
        tokens.push(regToken);

        this.emitStatus();
    },

    onAddTokenFailed: function(actionID, err) {
        console.warn("onAddTokenFailed: ", actionID, err);
       this.onError(actionID, err);
    }
});

module.exports = RegistrationTokenStore;
